import React, { useEffect, useState, useRef } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'

import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import DataTable from 'Shared/Components/DataTable'

const SystemUsers = () => {
  const { t } = useTranslation()
  const { send } = useFetchData()
  const { setPageLoading } = useOutletContext()

  const [users, setUsers] = useState([])

  const tableRef = useRef()

  const loadData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/user/project_users`,
      returnType: "json"
    })

    setUsers(body.map((i) => ({
      "user_id": i["user_id"],
      "username": i["username"],
      "email": i["email"],
      "role": i["role"],
      "roleName": t(`users_role_${i["role"]}`)
    })))
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await loadData()

      setPageLoading(false)
    }

    init()
  }, [])

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={users} count={null} ref={tableRef}
              columns={{
                "username": { "label": t("users_username"), "sorting": false, "nowrap": true },
                "email": { "label": t("users_email"), "sorting": false, "nowrap": true },
                "roleName": { "label": t("users_role"), "sorting": false, "nowrap": true },  
              }}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 
  </>)
}

export default SystemUsers
